
              import { defineAsyncComponent } from 'vue'
              import SharedNodeRef from './app/render/components/generic/SharedNodeRef/SharedNodeRef.vue'
import Image from './app/render/components/devtest/Image/Image.vue'
import Text from './app/render/components/devtest/Text/Text.vue'
import Container from './app/render/components/devlayout/Container/LayoutContainer.vue'
import StyledContainer from './app/render/components/devlayout/StyledContainer/StyledContainer.vue'
import CTA from './app/render/components/buttons/CTAButton/CTAButton.vue'
import Checkout from './app/render/components/devtest/Checkout/Checkout.vue'
import RitchTextTP from './app/render/components/devtest/RitchTextTP/RitchTextTP.vue'
import ColumnsOrRows from './app/render/components/devlayout/ColumnsOrRows/ColumnsOrRows.vue'
import IconList from './app/render/components/devtest/IconList/IconList.vue'
import ProgressBarPOC from './app/render/components/devtest/ProgressBarPOC/ProgressBarPOC.vue'
import Carousel from './app/render/components/devlayout/Carousel/Carousel.vue'
import BMIVisual from './app/render/components/devtest/BMIVisual/BMIVisual.vue'
import Signature from './app/render/components/devtest/Signature/Signature.vue'
import Confetti from './app/render/components/devtest/Confetti/Confetti.vue'
import EmailInput from './app/render/components/devtest/EmailInput/EmailInput.vue'
import PageBackground from './app/render/components/devlayout/PageBackground/PageBackground.vue'
import ProgressDonut from './app/render/components/devtest/ProgressDonut/ProgressDonut.vue'
import GoalLineChart from './app/render/components/devtest/GoalLineChart/GoalLineChart.vue'
import OptionMultiSelect from './app/render/components/devtest/OptionMultiSelect/OptionMultiSelect.vue'
import OptionSingleSelect from './app/render/components/devtest/OptionSingleSelect/OptionSingleSelect.vue'
import SteppedSlider from './app/render/components/devtest/SteppedSlider/SteppedSlider.vue'
import MeasurementSwitcher from './app/render/components/devtest/MeasurementSwitcher/MeasurementSwitcher.vue'
import WeightInput from './app/render/components/devtest/WeightInput/WeightInput.vue'
import HeightInput from './app/render/components/devtest/HeightInput/HeightInput.vue'
import AgeInput from './app/render/components/devtest/AgeInput/AgeInput.vue'
import SpeechBubble from './app/render/components/devlayout/SpeechBubble/SpeechBubble.vue'
import TextInput from './app/render/components/devtest/TextInput/TextInput.vue'
import Heading from './app/render/components/devtext/Heading/HeadingText.vue'
import SelectionList from './app/render/components/devtest/SelectionList/SelectList.vue'
import SavedCard from './app/render/components/devtest/SavedCard/SavedCard.vue'
import StickyContainer from './app/render/components/devlayout/StickyContainer/StickyContainer.vue'
import Timer from './app/render/components/devtest/Timer/Timer.vue'
import OptionSelectItem from './app/render/components/devtest/OptionSelectItem/OptionSelectItem.vue'
import OfferSelectV2 from './app/render/components/devtest/OfferSelectV2/OfferSelectV2.vue'
import Scratchoff from './app/render/components/devtest/Scratchoff/Scratchoff.vue'
import Timeout from './app/render/components/devtest/Timeout/Timeout.vue'
import SplitBackground from './app/render/components/devlayout/SplitBackground/SplitBackground.vue'
import ComponentSlot from './app/render/components/generic/ComponentSlot/ComponentSlot.vue'
              export default {
                'SharedNodeRef': { component: SharedNodeRef },
'Image': { component: Image },
'Text': { component: Text },
'Container': { component: Container },
'StyledContainer': { component: StyledContainer },
'CTA': { component: CTA },
'Checkout': { component: Checkout },
'RitchTextTP': { component: RitchTextTP },
'ColumnsOrRows': { component: ColumnsOrRows },
'IconList': { component: IconList },
'ProgressBarPOC': { component: ProgressBarPOC },
'Carousel': { component: Carousel },
'BMIVisual': { component: BMIVisual },
'Signature': { component: Signature },
'Confetti': { component: Confetti },
'EmailInput': { component: EmailInput },
'PageBackground': { component: PageBackground },
'ProgressDonut': { component: ProgressDonut },
'GoalLineChart': { component: GoalLineChart },
'OptionMultiSelect': { component: OptionMultiSelect },
'OptionSingleSelect': { component: OptionSingleSelect },
'SteppedSlider': { component: SteppedSlider },
'MeasurementSwitcher': { component: MeasurementSwitcher },
'WeightInput': { component: WeightInput },
'HeightInput': { component: HeightInput },
'AgeInput': { component: AgeInput },
'SpeechBubble': { component: SpeechBubble },
'TextInput': { component: TextInput },
'Heading': { component: Heading },
'SelectionList': { component: SelectionList },
'SavedCard': { component: SavedCard },
'StickyContainer': { component: StickyContainer },
'Timer': { component: Timer },
'OptionSelectItem': { component: OptionSelectItem },
'OfferSelectV2': { component: OfferSelectV2 },
'Scratchoff': { component: Scratchoff },
'Timeout': { component: Timeout },
'SplitBackground': { component: SplitBackground },
'ComponentSlot': { component: ComponentSlot }
              }
            